export const REGEX_SCRIPT_TAG = /<script[\s\S]*?>[\s\S]*?<\/script>/gi
export const REGEX_SPECIAL_CHAR_WITH_EMOJIS = /[#$%^*\-[\]{};:\\|]+/g
export const REGEX_SPECIAL_CHARACTERS = /[#$%^*[\]{};:\\|]+/g
export const REGEX_HTML_TAG = /<[^>]*>/gi
